module.exports = __webpack_public_path__ + "static/media/seat2_red.d7418a58.svg";